import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePublicCategories } from 'modules/test/hooks/usePublicCategories';
import { catalogCategories, categoryLabelFor } from 'pages/Portal/catalogCategories';

/**
 * Turns the category a test stores (a slug such as "dtm" or an alias such as
 * "umumiy-fanlar") into its label in the active language, for the "Category"
 * column of every tests list. Returns undefined for a test with no category.
 */
export function useTestCategoryLabel(): (raw?: string) => string | undefined {
  const { t, i18n } = useTranslation();
  const { data } = usePublicCategories();
  const categories = useMemo(() => catalogCategories(data?.data, t, i18n.language), [data, t, i18n.language]);

  return useCallback(
    (raw?: string) => {
      const value = raw?.trim();
      if (!value) return undefined;
      // A slug the catalog doesn't know falls back to its own translation, then to itself.
      return categoryLabelFor(categories, value) ?? t(value, { defaultValue: value, nsSeparator: false, keySeparator: false });
    },
    [categories, t],
  );
}
